import LoginSignupHolder from './LoginSignupHolder';
export default LoginSignupHolder;